module.exports = __webpack_public_path__ + "static/media/umbrella-loader-green.4626ce6d.gif";